// extracted by mini-css-extract-plugin
var _1 = "FcEiRiuyNE9zXh_5tZuO";
export { _1 as "buildingModifierTable" }
